var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result"},[(_vm.model.type != 20)?_c('unit',{staticStyle:{"margin-right":"92px"},attrs:{"title":"总分","value":_vm.model.score}}):_vm._e(),_c('unit',{attrs:{"title":"结论","value":_vm.model.result}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }